import React from 'react';

interface ProfilePictureProps {
  src: string;
  alt?: string;
  className?: string;
  'aria-hidden'?: boolean;
}

export const ProfilePicture: React.FC<ProfilePictureProps> = ({
  src,
  alt = '',
  className,
  'aria-hidden': ariaHidden
}) => {
  return (
    <img
      src={src}
      alt={alt}
      className={className}
      aria-hidden={ariaHidden}
      style={{
        width: '100%',
        display: 'block'
      }}
    />
  );
};
